/**
 * Demo persona constants for investor / live demos.
 */

export const DEMO_INDIVIDUAL_EMAIL = 'demo@ertzyx.com';
export const DEMO_INSTITUTION_EMAIL = 'demoins@ertzyx.com';

export const DEMO_INDIVIDUAL_DISPLAY_NAME = 'Sophie Lin';
export const DEMO_INDIVIDUAL_TITLE = 'Newcomer Journey Builder';

export const DEMO_INSTITUTION_DISPLAY_NAME = 'Pacific Heritage Museum';
export const DEMO_INSTITUTION_TITLE = 'Community Memory Archive';

export function isDemoIndividualUser(email: string | undefined | null): boolean {
  return email === DEMO_INDIVIDUAL_EMAIL;
}

export function isDemoInstitutionUser(email: string | undefined | null): boolean {
  return email === DEMO_INSTITUTION_EMAIL;
}

export function shouldUseDemoData(email: string | undefined | null): boolean {
  if (isDemoIndividualUser(email) || isDemoInstitutionUser(email)) return true;
  if (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_ENABLE_DEMO_DATA === 'true')
    return true;
  return false;
}
